<template>
  <div>
    <div class="row pl-4">
      <div class="col-xl-2 col-md-2">
        <vs-input icon="search" label="Búsqueda nombre" class="inputx" placeholder="Buscar..." v-model="search"
          @input="filtrarItems()" />
      </div>
      <div class="col-xl-2 col-md-2">
        <vs-input icon="search" label="Búsqueda origen" class="inputx" placeholder="Buscar..." v-model="searchOrigin"
          @input="filtrarItems()" />
      </div>
      <div class="col-xl-2 col-md-2">
        <vs-input icon="search" label="Búsqueda destino" class="inputx" placeholder="Buscar..."
          v-model="searchDestination" @input="filtrarItems()" />
      </div>
    </div>
    <div v-if="!dataFilter" class="table-responsive">
      <table class="table">
        <thead>
          <slot name="columns">
            <tr>
              <th v-for="column in columns" :key="column">{{ column }}</th>
              <th>Opciones</th>
            </tr>
          </slot>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data" :key="index">
            <slot :row="item">
              <td v-for="column in columns" :key="column" v-if="hasValue(item, column)">{{ itemValue(item, column) }}
              </td>
              <td>
                <button type="button" class="navbar-toggler navbar-toggler-right" aria-controls="navigation-index"
                  aria-expanded="false" aria-label="Toggle navigation" @click="functionComponentEdit(item)">
                  <i style="color: #0d6efd;" class="nc-icon nc-settings-gear-64"></i></button>
                <button type="button" class="navbar-toggler navbar-toggler-right" aria-controls="navigation-index"
                  aria-expanded="false" aria-label="Toggle navigation" @click="functionComponentDelete(item)">
                  <i style="color: #0d6efd;" class="nc-icon nc-simple-remove"></i></button>
              </td>
            </slot>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="table-responsive">
      <table class="table">
        <thead>
          <slot name="columns">
            <tr>
              <th v-for="column in columns" :key="column">{{ column }}</th>
              <th>Opciones</th>
            </tr>
          </slot>
        </thead>
        <tbody>
          <tr v-for="(item, index) in dataFilter" :key="index">
            <slot :row="item">
              <td v-for="column in columns" :key="column" v-if="hasValue(item, column)">{{ itemValue(item, column) }}
              </td>
              <td>
                <button type="button" class="navbar-toggler navbar-toggler-right" aria-controls="navigation-index"
                  aria-expanded="false" aria-label="Toggle navigation" @click="functionComponentEdit(item)">
                  <i style="color: #0d6efd;" class="nc-icon nc-settings-gear-64"></i></button>
                <button type="button" class="navbar-toggler navbar-toggler-right" aria-controls="navigation-index"
                  aria-expanded="false" aria-label="Toggle navigation" @click="functionComponentDelete(item)">
                  <i style="color: #0d6efd;" class="nc-icon nc-simple-remove"></i></button>
              </td>
            </slot>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</template>
<script>
export default {
  data() {
    return {
      search: '',
      searchDestination: '',
      searchOrigin: '',
      dataFilter: '',
    }
  },
  name: 'l-table',
  props: {
    columns: Array,
    data: Array
  },
  watch: {
  },
  computed: {

  },
  methods: {
    filtrarItems() {
      const search = this.search ? this.search.toLowerCase() : '';
      const searchOrigin = this.searchOrigin ? this.searchOrigin.toLowerCase() : '';
      const searchDestination = this.searchDestination ? this.searchDestination.toLowerCase() : '';

      this.dataFilter = this.data.filter(item => {
        const matchesSearch = search
          ? item.nombre.toLowerCase().includes(search)
          : true;

        const matchesSearchOrigin = searchOrigin
          ? item.origin.toLowerCase().includes(searchOrigin)
          : true;

        const matchesSearchDestination = searchDestination
          ? item.destination.toLowerCase().includes(searchDestination)
          : true;

        return matchesSearch && matchesSearchOrigin && matchesSearchDestination;
      });
    },
    hasValue(item, column) {
      return item[column.toLowerCase()] !== 'undefined'
    },
    itemValue(item, column) {
      return item[column.toLowerCase()]
    },
    functionComponentDelete(item) {
      this.$emit('functionComponentDelete', item);
    },
    functionComponentEdit(item) {
      this.$emit('functionComponentEdit', item);
    },
  }
}
</script>
<style>
.table-responsive {
  width: 100%;
  overflow-x: auto;
}
</style>
